import React, { Component } from 'react';
import _ from 'lodash';
import compose from 'recompose/compose';
import { withTranslation } from 'react-i18next';

import styles from './styles';
import {
  withStyles,
  IconButton,
  Menu,
  MenuItem,
  Button
} from '@material-ui/core';
import {
  HelpOutlineOutlined as HelpIconOutline,
  HelpRounded as HelpIcon
} from '@material-ui/icons';

class HelpMenu extends Component {
  state = {
    anchorEl: null,
    isOpen: false
  };

  handleMenu = event => {
    this.setState({ anchorEl: event.currentTarget, isOpen: true });
  };

  handleMenuClose = () => {
    this.setState({ anchorEl: null, isOpen: false });
  };

  handleClick = url => {
    this.handleMenuClose();
    // window.location.href = url;
    window.open(url, '_blank').focus();
  };

  render() {
    const { anchorEl, isOpen } = this.state;
    const { classes, t, className } = this.props;

    return (
      <div className={className}>
        {/* <IconButton
          aria-controls="menu-appbar-2"
          aria-haspopup="true"
          onClick={this.handleMenu}
          color="primary"
          title={t('Pagalba')}>
          <HelpIcon />
        </IconButton> */}
        <Button
          endIcon={<HelpIconOutline />}
          color="primary"
          onClick={this.handleMenu}>
          {`${t('Pagalba')}, ${t('D.U.K.')}`}
        </Button>
        <Menu
          id="menu-appbar-2"
          anchorEl={anchorEl}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right'
          }}
          keepMounted
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right'
          }}
          open={isOpen}
          onClose={this.handleMenuClose}
        >
          <MenuItem className="menu-header-item">
            {t('Vartotojo instrukcijos')}
          </MenuItem>
          <MenuItem
            onClick={() => this.handleClick('/help/projekto-instrukcija.pdf')}>
            {t('Projekto ir skaičiavimų objekto sukūrimas')}
          </MenuItem>
          <MenuItem
            onClick={() => this.handleClick('/help/samatos-instrukcija.pdf')}>
            {t('Statinių statybos sąmatų skaičiavimai')}
          </MenuItem>
          <MenuItem
            onClick={() => this.handleClick('/help/ntk-instrukcija.pdf')}>
            {t('Statinių kainynas NTK. Atkuriamosios vertės skaičiavimai')}
          </MenuItem>

          <MenuItem className="menu-header-item">
            {t('Video pamokos')}
          </MenuItem>
          <MenuItem
            onClick={() => this.handleClick('https://youtu.be/Hvw5_oO9wWQ')}>
            {t('Sąmatos')}: {t('Projekto ir objekto sukūrimas')}
          </MenuItem>
          <MenuItem
            onClick={() => this.handleClick('https://youtu.be/M6D9a-j4A18')}>
            {t('Sąmatos')}: {t('Įkainių paieška ir įvedimas')}
          </MenuItem>
          <MenuItem
            onClick={() => this.handleClick('https://youtu.be/DPoOnegB0hw')}>
            {t('Sąmatos')}: {t('Kainos sudėtis ir nustatymai')}
          </MenuItem>
          <MenuItem
            onClick={() => this.handleClick('https://youtu.be/yrfbbJxqB9o')}>
            {t('Sąmatos')}: {t('Resursų įvedimas')}
          </MenuItem>
          <MenuItem
            onClick={() => this.handleClick('https://youtu.be/i-k6ggp24GM')}>
            {t('Sąmatos')}: {t('Individualaus įkainio sukūrimas')}
          </MenuItem>
          <MenuItem
            onClick={() => this.handleClick('https://youtu.be/zWvwl0Wnqxg')}>
            {t('Sąmatos')}: {t('Skaičiavimų kopijos sukūrimas')}
          </MenuItem>
          <MenuItem
            onClick={() => this.handleClick('https://youtu.be/-6qpA79vyfU')}>
            {t('Sąmatos')}: {t('Duomenų įkėlimas iš kito objekto')}
          </MenuItem>
          <MenuItem
            onClick={() => this.handleClick('https://youtu.be/N9fhi27fTEg')}>
            {t('Sąmatos')}: {t('Suvestinės sąmatos formavimas')}
          </MenuItem>
          <MenuItem
            onClick={() => this.handleClick('https://youtu.be/LeAqJlYOmTc')}>
            {t('Sąmatos')}: {t('Suvestinės sąmatos redagavimas')}
          </MenuItem>
          <MenuItem
            onClick={() => this.handleClick('https://youtu.be/F3Pvo00CeQM')}>
            {t('Sąmatos')}: {t('Skaičiavimų įrašymas/atstatymas iš laikmenų')}
          </MenuItem>
          <MenuItem
            onClick={() => this.handleClick('https://youtu.be/R5d-j1FqlT0')}>
            {t('Sąmatos')}: {t('Skaičiavimų archyvavimas')}
          </MenuItem>
          <MenuItem
            onClick={() => this.handleClick('https://youtu.be/vC1jS2d22Qg')}>
            {t('Sąmatos')}: {t('Atliktų darbų aktavimas')}
          </MenuItem>
          <MenuItem
            onClick={() => this.handleClick('https://youtu.be/ei0khQwbMy0')}>
            {t('Sąmatos')}: {t('Papildomų darbų aktavimas')}
          </MenuItem>
        </Menu>
      </div>
    );
  }
}

export default compose(
  withStyles(styles),
  withTranslation()
)(HelpMenu);
